<template>
<div>
    <div class="row">
        <div :class="['col_12', {'loading_overlay': loading}]">
            <div class="card no_border">
                <div class="card-header">
                    <div class="card-title">{{ title }}</div>
                </div>
                <div class="card-body pl_0 pr_0">
                    <div class="row">
                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('name')}]">
                                <label>{{ $t('common.name') }}</label>
                                <input type="text" v-model="form.name" class="form_global">
                                <v-errors :errors="errorFor('name')" />
                            </div>
                        </div>
                        <div class="col_6">
                            <div :class="['form-group', {'has_error': errorFor('sort')}]">
                                <label>{{ $t('common.sort') }}</label>
                                <input type="integer" v-model="form.sort" class="form_global">
                                <v-errors :errors="errorFor('sort')" />
                            </div>
                        </div>
                    </div>
                    <div class="d_flex_end form_action_btn">
                        <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
                        <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE,
            title: this.$t('sidebar.thinking_areas.add_thinking_area'),
            cancelRouteName: 'settings_thinking_area',
            form: {
                name: '',
                sort: '',
            },
        }
    },
    mounted() {

    },
    created() {
        if (this.$route.name === 'settings_thinking_area_edit') {
            this.axios.get('/thinking-areas/' + this.$route.params.id)
                .then((response) => {
                    this.form = response.data.data;
                })
            this.title = this.$t('sidebar.thinking_areas.edit_thinking_area');
        }
    },
    methods: {
        submit() {
            this.allErrors = null;
            this.loading = true;

            let formData = new FormData()

            Object.keys(this.form).forEach(key => {
                formData.append(key, this.form[key] ? this.form[key] : '');
            })

            if (this.$route.name === 'settings_thinking_area_edit') {
                formData.append('_method', 'PATCH')

                this.axios.post('/thinking-areas/' + this.$route.params.id, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                    .then(() => {
                        this.$router.push({
                            name: 'settings_thinking_area'
                        });
                        this.showSuccessMsg(this.$t('common.updateSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.axios.post('/thinking-areas/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                    .then(() => {
                        this.$router.push({
                            name: 'settings_thinking_area'
                        });
                        this.showSuccessMsg(this.$t('common.addSuccess'))
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
